import update from 'immutability-helper';
import { AuthEpicsActions, AuthEpicsActionTypes } from './action';
import { CognitoUser } from 'amazon-cognito-identity-js';

export interface AuthEpicsState {
  isValidEmail: boolean;
  email: string;
  error: string;
  user: CognitoUser | null;
  signUpError: string;
  codeError: string;
  isLoading: boolean;
  isUser: boolean;
  session: any;
  id: string;
  signInError: string;
  forgotPasswordError: string;
  confirmPasswordError: string;
  signOutError: string;
}

export const initialAuthEpicsState: AuthEpicsState = {
  isValidEmail: false,
  email: null,
  error: null,
  user: null,
  signUpError: null,
  codeError: null,
  isUser: false,
  isLoading: false,
  id: null,
  session: {},
  signInError: null,
  forgotPasswordError: null,
  confirmPasswordError: null,
  signOutError: null,
};

export const EMAIL_REGEX = /^[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*@[a-z0-9-]+\.[a-z]+$/;

export function authEpicsReducer(state = initialAuthEpicsState, action: AuthEpicsActions) {
  switch (action.type) {
    case AuthEpicsActionTypes.INPUT_EMAIL:
      const { email } = action;
      if (EMAIL_REGEX.test(email)) {
        return update(state, {
          isValidEmail: { $set: true },
          email: { $set: action.email },
          error: { $set: null },
        });
      }
      return update(state, {
        isValidEmail: { $set: false },
        email: { $set: null },
        error: { $set: 'Incorrect email' },
      });
    case AuthEpicsActionTypes.SIGN_UP:
      return update(state, {
        isLoading: { $set: true },
        signUpError: { $set: null },
      });
    case AuthEpicsActionTypes.SIGN_UP_SUCCEEDED:
      return update(state, {
        isLoading: { $set: false },
        user: { $set: action.user.user },
      });
    case AuthEpicsActionTypes.SIGN_UP_FAILED:
      return update(state, {
        isLoading: { $set: false },
        signUpError: { $set: action.error.message },
      });
    case AuthEpicsActionTypes.VERIFICATION_CODE:
      return update(state, {
        isLoading: { $set: true },
        codeError: { $set: null },
      });
    case AuthEpicsActionTypes.VERIFICATION_CODE_SUCCEDED:
      return update(state, {
        isLoading: { $set: false },
      });
    case AuthEpicsActionTypes.VERIFICATION_CODE_FAILED:
      return update(state, {
        isLoading: { $set: false },
        codeError: { $set: action.error.message },
      });
    case AuthEpicsActionTypes.SIGN_IN:
      return update(state, {
        isLoading: { $set: true },
        signInError: { $set: null },
      });
    case AuthEpicsActionTypes.SIGN_IN_SUCCEEDED:
      return update(state, {
        isLoading: { $set: false },
        session: { $set: action.session },
        isUser: { $set: true },
      });
    case AuthEpicsActionTypes.SIGN_IN_FAILED:
      return update(state, {
        isLoading: { $set: false },
        signInError: { $set: action.error.message },
      });
    case AuthEpicsActionTypes.FORGOT_PASSWORD:
      return update(state, {
        isLoading: { $set: true },
        forgotPasswordError: { $set: null },
      });
    case AuthEpicsActionTypes.FORGOT_PASSWORD_SUCCEEDED:
      return update(state, {
        isLoading: { $set: false },
      });
    case AuthEpicsActionTypes.FORGOT_PASSWORD_FAILED:
      return update(state, {
        isLoading: { $set: false },
        forgotPasswordError: { $set: action.error.message },
      });
    case AuthEpicsActionTypes.CONFIRM_PASSWORD:
      return update(state, {
        isLoading: { $set: true },
        confirmPasswordError: { $set: null },
      });
    case AuthEpicsActionTypes.CONFIRM_PASSWORD_SUCCEEDED:
      return update(state, {
        isLoading: { $set: false },
      });
    case AuthEpicsActionTypes.CONFIRM_PASSWORD_FAILED:
      return update(state, {
        isLoading: { $set: false },
        confirmPasswordError: { $set: action.error.message },
      });

    case AuthEpicsActionTypes.INIT_CLIENT_SUCCEEDED:
      const { response: session } = action;
      const emailAttribute = session[2];
      const emailValue = emailAttribute ? emailAttribute.Value : null;
      const valueAttribute = session[0];
      const value = valueAttribute ? valueAttribute.Value : null;

      return update(state, {
        session: { $set: session },
        email: { $set: emailValue },
        isUser: { $set: true },
        id: { $set: value },
        isLoading: { $set: false },
      });
    case AuthEpicsActionTypes.SIGN_OUT:
      return update(state, {
        signOutError: { $set: null },
      });
    case AuthEpicsActionTypes.SIGN_OUT_SUCCEEDED:
      return update(state, {
        isUser: { $set: false },
      });
    case AuthEpicsActionTypes.SIGN_OUT_FAILED:
      return update(state, {
        signOutError: { $set: action.error.message },
      });
    default:
      return state;
  }
}
